/**
 * This mixin is the Free Download Workflow that is shared between Infinity Store and HTML5 Store
 * */
export default {
  props: {
    "downloadable": {
      default: {}
    }
  },
  data() {
    return {
      name: "",
      email: "",
      success: false,
      error: false,
      message: "",
      loading: false,
      isYoutubeExchangeDismissed: false
    };
  },
  computed: {
    loggedInUser() {
      return this.$store.state.loggedInUser;
    },
    isYoutubeExchange() {
      return this.downloadable.exchange.accounts.youtube?.enabled;
    },
    isYoutubeFollowed() {
      return this.isYoutubeExchange && this.downloadable.exchange.accounts.youtube.isFollowing;
    },
    showDownloadNow() {
      return this.downloadable.exchange.url
          && !(this.isYoutubeExchange
            && !this.isYoutubeFollowed
            && !this.isYoutubeExchangeDismissed);
    },
    isTwitterExchange() {
      return this.downloadable.exchange.accounts.twitter
        && this.downloadable.exchange.accounts.twitter.enabled;
    },
    isTwitterFollowed() {
      return this.isTwitterExchange && this.downloadable.exchange.accounts.twitter.isFollowing;
    }
  },
  methods: {
    connectTwitter() {
      window.open(this.downloadable.exchange.accounts.twitter.connectUrl, "_blank", "width=600,height=400,left=600,top=300menubar=no");

      this.handlePopupEvents();
    },

    connectYouTube() {
      window.open(this.downloadable.exchange.accounts.youtube.connectUrl, "_blank", "width=600,height=400,left=600,top=300menubar=no");

      this.handlePopupEvents();
    },

    handlePopupEvents() {
      const component = this;
      const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
      const eventEmitter = window[eventMethod];
      const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
      // Listen to message from child window
      eventEmitter(messageEvent, function(e) {
        if (e.origin !== ab.siteUrl) {
          return;
        }

        if (e.data.connected) {
          component.socialConnected();
        }
      }, false);
    },

    socialConnected() {
      this.loading = true;

      this.$http.get(`/freedownloads/beat/${this.downloadable.music.id}/`)
        .then((response) => {
          this.$store.commit("downloadable", {
            downloadable: {
              music: this.downloadable.music,
              exchange: response.data
            }
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    emailDownload() {
      this.success = false;
      this.error = false;
      this.message = "";

      if (!this.loggedInUser && (this.name === "" || this.email === "")) {
        this.error = true;
        this.message = "Please enter both your name and email address";
        return false;
      }

      this.loading = true;
      const data = {
        type: this.downloadable.music.getType(),
        id: this.downloadable.music.id
      };

      if (!this.loggedInUser) {
        data.name = this.name;
        data.email = this.email;
      }

      this.$http.get(`/freedownloads`, {
        params: {
          name: this.name,
          email: this.email,
          type: this.downloadable.music.getType(),
          id: this.downloadable.music.id
        }
      }).then((response) => {
        if (this.loggedInUser && response.data.url !== undefined) {
          this.downloadable.exchange.url = response.data.url;
        } else {
          this.success = true;
          this.error = false;
          this.message = "Email has been sent. Please check your email for the download link.";
        }
      }).catch((error) => {
        this.success = false;
        this.error = true;
        this.message = "There has been an error, please make sure you enter a valid name and email address.";
      }).finally(() => {
        this.loading = false;
      });
    },

    dismissYouTube() {
      this.isYoutubeExchangeDismissed = true;
    }
  },
  watch: {
    downloadable() {
      this.success = false;
      this.error = false;
      this.message = "";
      this.isYoutubeExchangeDismissed = false;
      this.name = "";
      this.email = "";
    }
  }
};
